import { camelizeResource, pascalizeResource } from '../../helpers/resource';
import * as dateHelpers from '../../helpers/date';

export const normalizeEvent = (props) => {
  const camelized = camelizeResource(props);
  camelized.id = camelized.id.toString();

  const date = new Date(camelized.date);
  const day = dateHelpers.formatDay(date);

  camelized.date = date;
  camelized.dateTime = {
    date: `${day} ${camelized.displayDate.split(' ')[0]}`,
    time: dateHelpers.formatTime(date),

    day,
    dayShort: day.substring(0,3).toUpperCase(),
    dayNum: date.getDate(),
    month: dateHelpers.formatMonth(date),

    epochSeconds: Math.round(date.getTime() / 1000),
  };

  camelized.displayVenue = `${camelized.venue}, ${camelized.city}, ${camelized.stateProvince}`;

  return camelized;
};

export const fromLatest = normalizeEvent;
export const fromShow = normalizeEvent;

export const fromTickets = props => ({
  ...camelizeResource(props),
  ticketList: props.TicketList.map(ticket => camelizeResource(ticket)),
});

export const fromTicketsCurated = props => ({
  ...camelizeResource(props),
  ticketList: props.RecommendedList ? [] : props.TicketList.map(ticket => camelizeResource(ticket)),
  recommendedList: props.RecommendedList ? props.RecommendedList.map(ticket => camelizeResource(ticket)) : [],
});

const getQuantity = props => {
  switch (props.quantity) {
    case 'any':
      return undefined;
    case '4+':
      return 4;
    default:
      return props.quantity;
  }
};

export const toTicketsCurated = (props) => ({
  ...pascalizeResource(props),
  Quantity: getQuantity(props),
});



// WEBPACK FOOTER //
// ./src/resources/events/normalizers.js